import { render, staticRenderFns } from "./ModalChat.vue?vue&type=template&id=701e9a3c&scoped=true"
import script from "./ModalChat.vue?vue&type=script&lang=js"
export * from "./ModalChat.vue?vue&type=script&lang=js"
import style0 from "./ModalChat.vue?vue&type=style&index=0&id=701e9a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e9a3c",
  null
  
)

export default component.exports